import styled from '@emotion/styled';

const Paragraph = styled.p`
  font-size: 1.3em;
`;

export default Paragraph;
